var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainControl01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.31,13.39H1.69V2.61h12.62V13.39z M2.19,12.89h11.62V3.11H2.19V12.89z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2.37,13.24 1.89,12.67 13.62,2.79 14.11,3.36  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainControl01);
export default __webpack_public_path__ + "static/media/MainControl-01.d6c119aadbed2eaf0c2ecf1323a70514.svg";
export { ForwardRef as ReactComponent };